// ImgCardSkeleton.jsx
import React from "react";

const ImgCardSkeleton = () => {
  const DAY_ORDER = ["M", "Tu", "W", "Th", "F", "Sa", "Su"];

  return (
    <section>
      <div className="max-w-full w-full bg-white rounded-xl border border-[#EEEEEE] p-4 shadow-sm">
        {/* Top section */}
        <div className="flex items-start gap-4">
          <div className="rounded-lg h-24 w-24 shimmer shrink-0" />
          <div className="flex flex-col gap-2 flex-1">
            <div className="h-5 w-3/4 shimmer rounded" />
            <div className="h-4 w-1/2 shimmer rounded" />
          </div>
        </div>

        {/* Description */}
        <div className="mt-3 h-4 shimmer rounded w-full" />
        <div className="mt-1 h-4 shimmer rounded w-5/6" />

        {/* Days row */}
        <div className="mt-4 flex gap-2">
          {DAY_ORDER.map((day, index) => (
            <div key={index} className="h-8 w-8 rounded-md shimmer" />
          ))}
        </div>

        {/* Meal type + toggle */}
        <div className="flex justify-between items-center mt-4">
          <div className="flex gap-4">
            <div className="h-3 w-3 shimmer rounded-full" />
            <div className="h-3 w-3 shimmer rounded-full" />
          </div>
          <div className="h-8 w-16 shimmer rounded" />
        </div>

        {/* Footer actions */}
        <div className="flex justify-between items-center mt-4 pt-2">
          <div className="h-4 w-20 shimmer rounded" />
          <div className="h-4 w-20 shimmer rounded" />
        </div>
      </div>
    </section>
  );
};

export default ImgCardSkeleton;
